import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal } from '@angular/core';
import { CtaButton, OptionChip } from '@/shared/components';
import { TimeSlotPayload, TimeSlotGroup } from '../../interfaces';
import { CTAButtonVariant, OptionChipMode } from '@/shared/enums';

@Component({
  selector: 'bevvi-time-slot-payload',
  imports: [OptionChip, CtaButton],
  templateUrl: './time-slot-payload.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSlotPayloadComponent {
  public readonly payload = input.required<TimeSlotPayload>();
  public readonly disabled = input(false);

  public readonly userReply = output<string>();

  protected readonly CTAButtonVariant = CTAButtonVariant;
  protected readonly OptionChipMode = OptionChipMode;

  protected readonly groups = signal<TimeSlotGroup[]>([]);

  protected readonly selectedLabel = computed(() => {
    for (const group of this.groups()) {
      const slot = group.slots.find((s) => s.selected);
      if (slot) return slot.label;
    }
    return '';
  });

  constructor() {
    effect(() => {
      this.groups.set(
        this.payload().groups.map((g) => ({
          ...g,
          slots: g.slots.map((s) => ({ ...s, selected: false })),
        })),
      );
    });
  }

  public selectSlot(slotId: string): void {
    if (this.disabled()) return;
    this.groups.update((gs) =>
      gs.map((g) => ({
        ...g,
        slots: g.slots.map((s) => ({ ...s, selected: s.id === slotId })),
      })),
    );
  }

  public onSubmit(): void {
    const label = this.selectedLabel();
    if (label) this.userReply.emit(label);
  }
}
